var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndexOf = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M12.426 13.078q-1.279 0-2.165-.887-.886-.885-.886-2.165c0-1.28.295-1.574.886-2.165q.885-.886 2.165-.886c1.28 0 1.575.295 2.165.886q.886.885.886 2.165a2.86 2.86 0 0 1-.61 1.784l2.629 2.629a.44.44 0 0 1 .129.328.45.45 0 0 1-.13.329.45.45 0 0 1-.328.129.45.45 0 0 1-.328-.13l-2.629-2.628a2.86 2.86 0 0 1-1.784.61Zm0-.94q.88 0 1.496-.615.617-.617.617-1.497t-.617-1.496q-.615-.615-1.496-.616c-.881-.001-1.085.205-1.496.616q-.616.616-.616 1.496t.616 1.497 1.496.616ZM6 16.575a.45.45 0 0 1 .45-.45h5.1a.45.45 0 0 1 0 .9h-5.1a.45.45 0 0 1-.45-.45"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndexOf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/index-of.7dbdb2ac.svg";